import { Table, TableBody, TableRow } from '@mui/material';
import { Order } from '../../../../components/StyledTableContentRaw';
import PaymentsTableHead from './components/TableHead';
import {
  TitleContainer,
  Container,
  CardTitle,
  CustomTableContainer,
  ExpansiveRowContainer,
  ExpandedTableContainer,
} from './components/styled';
import TableContainer from '@mui/material/TableContainer';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { IoMdAdd, IoMdRemove } from 'react-icons/io';
import { useState } from 'react';
import { IDebtsByUf } from '../../../../context/BatchPaymentContext';
import { IGetBatchConsultStatusResponse } from '../../../../hooks/types/BatchConsults';
import { IConsultsPackageModal } from '../../../../context/VehiclesContext';
import { sumDebts } from '../../../../utils/debtsProcessing';

export interface HeadCell {
  key?: string;
  label: string;
}

interface ITable {
  title: string;
  data?: IDebtsByUf[];
  order: Order;
  setOrder: React.Dispatch<React.SetStateAction<Order>> | any;
  orderBy: string;
  setOrderBy: React.Dispatch<React.SetStateAction<string>>;
  isLoading: boolean;
  error: any;
  isLoadingRecreatingBatch?: boolean;
}

function handleNumbersToMoneyStr(value: number | undefined) {
  return `R$ ${(value ?? 0)?.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

function ExpandedTable({ uf, data }: any) {
  return (
    <ExpandedTableContainer>
      <Table className="teste">
        <TableBody className="teste">
          {data.map((columns: any) => {
            return (
              <TableRow>
                <td>{uf}</td>
                <td>{columns.placa ?? '--'}</td>
                <td>
                  {columns.ipva > 0
                    ? handleNumbersToMoneyStr(columns.ipva)
                    : '--'}
                </td>
                <td>
                  {columns.licenciamento > 0
                    ? handleNumbersToMoneyStr(columns.licenciamento)
                    : '--'}
                </td>
                <td>
                  {columns.multas > 0
                    ? handleNumbersToMoneyStr(columns.multas)
                    : '--'}
                </td>
                <td>
                  {columns.dpvat > 0
                    ? handleNumbersToMoneyStr(columns.dpvat)
                    : '--'}
                </td>
                <td>
                  {columns.outros > 0
                    ? handleNumbersToMoneyStr(columns.outros)
                    : '--'}
                </td>
                <td>
                  {columns.total > 0
                    ? handleNumbersToMoneyStr(columns.total)
                    : '--'}
                </td>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </ExpandedTableContainer>
  );
}

function ExpansiveRowsTable({ data }: any) {
  const [openedRows, setOpenedRows] = useState<{ [key: string]: boolean }[]>(
    [],
  );

  function handleExpandRow(expanded: boolean, uf: string | undefined) {
    if (uf) {
      setOpenedRows((prev) => ({ ...prev, [uf]: expanded }));
    }
  }

  function sumAllRowsColumns(data: IDebtsByUf[]) {
    const sumOfDebtsByUf = data.map((debts) => ({
      uf: debts.uf,
      ipva: sumDebts(debts?.data, 'ipva'),
      licenciamento: sumDebts(debts?.data, 'licenciamento'),
      multas: sumDebts(debts?.data, 'multas'),
      dpvat: sumDebts(debts?.data, 'dpvat'),
      outros: sumDebts(debts?.data, 'outros'),
      total: sumDebts(debts?.data, 'total'),
    }));

    return [
      // "TOTAL UFs",
      '',
      sumDebts(sumOfDebtsByUf, 'ipva'),
      sumDebts(sumOfDebtsByUf, 'licenciamento'),
      sumDebts(sumOfDebtsByUf, 'multas'),
      sumDebts(sumOfDebtsByUf, 'dpvat'),
      sumDebts(sumOfDebtsByUf, 'outros'),
      sumDebts(sumOfDebtsByUf, 'total'),
    ];
  }

  return (
    <div className="expansive-rows-table">
      {data.map((row: any, index: number) => {
        const ipvaTotal = sumDebts(row?.data, 'ipva');
        const licenciamentoTotal = sumDebts(row?.data, 'licenciamento');
        const multasTotal = sumDebts(row?.data, 'multas');
        const dpvatTotal = sumDebts(row?.data, 'dpvat');
        const outrosTotal = sumDebts(row?.data, 'outros');
        const total =
          ipvaTotal +
          licenciamentoTotal +
          multasTotal +
          dpvatTotal +
          outrosTotal;

        const columns = [
          null,
          ipvaTotal,
          licenciamentoTotal,
          multasTotal,
          dpvatTotal,
          outrosTotal,
          total,
        ];

        return (
          <Accordion
            onChange={(event: React.SyntheticEvent, expanded: boolean) =>
              handleExpandRow(expanded, row?.uf)
            }
          >
            <AccordionSummary aria-controls="panel1-content" id="panel1-header">
              <ExpansiveRowContainer isEven={index % 2 === 0}>
                <div className="expansive-row-cell">
                  {openedRows[row?.uf] ? (
                    <IoMdRemove
                      style={{
                        color: '#005EAD',
                        fontSize: '18px',
                      }}
                    />
                  ) : (
                    <IoMdAdd
                      style={{
                        color: '#005EAD',
                        fontSize: '18px',
                      }}
                    />
                  )}
                  <span
                    style={{ whiteSpace: 'nowrap' }}
                  >{`TOTAL ${row.uf}`}</span>
                </div>
                {columns.map((cell: null | number, index: number) => (
                  <div className="expansive-row-cell">
                    {index > 0 && (
                      <span>
                        {cell
                          ? `R$ ${(cell ?? 0)?.toLocaleString('pt-BR', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}`
                          : '--'}
                      </span>
                    )}
                  </div>
                ))}
              </ExpansiveRowContainer>
            </AccordionSummary>
            <AccordionDetails>
              <ExpandedTable uf={row.uf} data={row.data} />
            </AccordionDetails>
          </Accordion>
        );
      })}
      <ExpansiveRowContainer isFooterRow>
        <div className="expansive-row-cell">
          <span>TOTAL UFs</span>
        </div>
        {sumAllRowsColumns(data).map((cell: string | number, index: number) => (
          <div className="expansive-row-cell">
            {index > 0 && (
              <span>
                {cell
                  ? `R$ ${(cell ?? 0)?.toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`
                  : '--'}
              </span>
            )}
          </div>
        ))}
      </ExpansiveRowContainer>
    </div>
  );
}

function LoadingExpandedTable({ uf, data }: any) {
  return (
    <ExpandedTableContainer>
      <Table className="teste">
        <TableBody className="teste">
          {data.map((columns: any) => {
            return (
              <TableRow>
                <td>{uf}</td>
                <td>{columns.placa ?? '--'}</td>

                {Array.from({ length: 6 }).map((_, index) => (
                  <td>--</td>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </ExpandedTableContainer>
  );
}

function LoadingExpansiveRowsTable() {
  const loadingLabel = 'Carregando...';
  return (
    <div className="expansive-rows-table">
      <Accordion>
        <AccordionSummary aria-controls="panel1-content" id="panel1-header">
          <ExpansiveRowContainer isEven={false}>
            <div className="expansive-row-cell">
              <span style={{ whiteSpace: 'nowrap' }}>{loadingLabel}</span>
            </div>
            {Array.from({ length: 7 }).map((_, index) => (
              <div className="expansive-row-cell">
                {index > 0 && <span>{loadingLabel}</span>}
              </div>
            ))}
          </ExpansiveRowContainer>
        </AccordionSummary>
        <AccordionDetails></AccordionDetails>
      </Accordion>
      <ExpansiveRowContainer isFooterRow>
        <div className="expansive-row-cell">
          <span>TOTAL UFs</span>
        </div>
        {Array.from({ length: 7 }).map((_, index) => (
          <div className="expansive-row-cell">
            <span>{index > 0 && <span>{loadingLabel}</span>}</span>
          </div>
        ))}
      </ExpansiveRowContainer>
    </div>
  );
}

export default function AsyncLoadingTable({
  title,
  data,
  order,
  setOrder,
  orderBy,
  setOrderBy,
  isLoadingRecreatingBatch,
}: ITable) {
  
  const heads: HeadCell[] = [
    { key: 'uf', label: 'UF' },
    { key: 'vehicle.placa', label: 'Placa' },
    { key: 'driver.name', label: 'IPVA' },
    { key: 'vehicle.licensingStatus', label: 'Licenciamento' },
    { key: 'fullTotalDebts', label: 'Multas' },
    { key: 'updated_at', label: 'DPVAT' },
    { key: 'updated_at', label: 'Outros' },
    { key: 'updated_at', label: 'Total' },
  ];

  const handleRequestSort = (
    event: React.MouseEvent<any>,
    property: string,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <Container>
      <TitleContainer>
        <CardTitle>
          <h2>{title}</h2>
        </CardTitle>
      </TitleContainer>
      <CustomTableContainer>
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size="medium"
            className="debts-table"
          >
            <PaymentsTableHead
              numSelected={0}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={data?.length ?? 0}
              heads={heads}
            />
          </Table>
          {isLoadingRecreatingBatch || !data ? (
            <LoadingExpansiveRowsTable />
          ) : (
            <ExpansiveRowsTable data={data} />
          )}
        </TableContainer>
      </CustomTableContainer>
    </Container>
  );
}
